import type { TimelineHour } from "../../api/types";

import { thunderDotStyle } from "./thunderScale";

interface Props {
  hours: TimelineHour[];
}

export default function ThunderDotsRow({ hours }: Props) {
  return (
    <div className="mb-1 flex h-[7px] w-full">
      {hours.map((hour) => {
        const style = thunderDotStyle(hour.thunderPopPct ?? 0);
        return (
          <div key={hour.localTime} className="flex flex-1 items-end justify-center">
            {style ? (
              <span
                className={`block rounded-full ${style.className}`}
                style={{ width: `${style.sizePx}px`, height: `${style.sizePx}px` }}
              />
            ) : null}
          </div>
        );
      })}
    </div>
  );
}
